import {
  DIRECT_SEND,
  CARD_ISSUING,
  COLLECTIONS,
  API_KEY_ENABLED,
  INCIDENT_PORTAL,
} from 'shared-components/src/utils/services';
import { admin, user } from '../../utils/roles';
import { apiDocs } from '../../utils/apidocs';
import policyDoc from '../../assets/Berkeley Client API Keys Management Policy.pdf';

// ---------
// Sidebar Items
// ---------
// Section
// The first level values are referred to as Sections
// The role for a section should be the lowest role of the entire section
// it will show the header in the side bar for that row
// Route
// Within each Section we have specific routes.
// Each specific route can also restrict the role furthur
// this means a user with a lower role will not see the route link
export default [
  {
    name: 'Dashboard',
    icon: 'home',
    role: user,
    location: '/',
    type: 'route',
  },
  {
    name: 'Direct Send',
    icon: 'bar-chart',
    role: user,
    service: DIRECT_SEND,
    routes: [
      {
        name: 'Create a Transfer',
        location: '/direct-send/create',
        type: 'route',
        role: admin,
      },
      {
        name: 'Transfer History',
        location: '/direct-send/transfers',
        type: 'route',
        role: user,
      },
      {
        name: 'Account Holders',
        location: '/direct-send/account-holders',
        type: 'route',
        role: admin,
      },
      {
        name: 'Reporting',
        location: '/direct-send/reports',
        type: 'route',
        role: user,
      },
      {
        name: 'Limits',
        location: '/direct-send/limits',
        type: 'route',
        role: user,
      },
    ],
  },
  {
    name: 'Card Issuing',
    icon: 'credit-card',
    role: user,
    service: CARD_ISSUING,
    routes: [
      {
        name: 'Programs',
        location: '/card-issuing/programs',
        type: 'route',
        role: user,
      },
      {
        name: 'Cardholders',
        location: '/card-issuing/cardholders',
        type: 'route',
        role: user,
      },
      {
        name: 'Value Loads',
        location: '/card-issuing/value-loads',
        type: 'route',
        role: user,
      },
      {
        name: 'Update Card',
        location: '/card-issuing/update-card',
        type: 'route',
        role: admin,
      },
      {
        name: 'Activate & Load Card',
        location: '/card-issuing/activate-load-card',
        type: 'route',
        role: admin,
      },
      {
        name: 'Unload Card by Proxy',
        location: '/card-issuing/unload-card',
        type: 'route',
        role: admin,
      }
    ],
  },
  {
    name: 'Collections',
    icon: 'send',
    role: user,
    service: COLLECTIONS,
    routes: [
      {
        name: 'Create a Collection',
        location: '/collections/create',
        type: 'route',
        role: admin,
      },
      {
        name: 'Collection History',
        location: '/collections/collections',
        type: 'route',
        role: user,
      },
      {
        name: 'Email Configuration',
        location: '/collections/configuration',
        type: 'route',
        role: admin,
      },
      {
        name: 'Reports',
        location: '/collections/reports',
        type: 'route',
        role: user,
      },
    ],
  },
  {
    name: 'API',
    icon: 'database',
    role: user,
    routes: [
      {
        name: 'Keys',
        location: '/api-keys',
        type: 'route',
        role: admin,
        isEnabled: API_KEY_ENABLED,
      },
      {
        name: 'Documentation',
        location: apiDocs,
        type: 'external',
        role: user,
      },
      {
        name: 'Keys Management Policy',
        location: policyDoc,
        type: 'external',
        role: user,
        isEnabled: API_KEY_ENABLED
      },
    ],
  },
  {
    name: 'Settings',
    icon: 'setting',
    role: user,
    routes: [
      {
        name: 'Company',
        location: '/settings/company',
        type: 'route',
        role: user,
      },
      {
        name: 'Team',
        location: '/settings/team',
        type: 'route',
        role: admin,
      },
      {
        name: 'Time Zone',
        location: '/settings/timezone',
        type: 'route',
        role: user,
      },
    ],
  },
  {
    name: 'System Status',
    icon: 'box-chart',
    role: user,
    location: '/system-status',
    type: 'route',
    service: INCIDENT_PORTAL,
  },
  {
    name: 'Help',
    icon: 'user',
    role: user,
    location: '/help',
    type: 'route',
  },
];
